import { Component } from '@angular/core';
import { CmsBannerComponent, CmsService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { UserInfoService } from '../../spartacus/services/user-info.service';

@Component({
  selector: 'app-errorpage-content',
  templateUrl: './errorpage-content.component.html',
  styleUrls: ['./errorpage-content.component.scss'],
  standalone: false
})
export class ErrorpageContentComponent {

  constructor(
    public cmsService: CmsService,
    public component: CmsComponentData<CmsBannerComponent>,
    private userInfoService: UserInfoService
  ) {}

  fourthnode: Observable<any> = this.component.data$;
  userLoggedIn: boolean = false;

  /**
   * Suppress the error UI for ANY URL ending with:
   *   /login/my-account
   *   /homepage/my-account
   *   /homepage/liveassist
   * Works for:
   *   /<site>/<curr>/<lang>/login/my-account
   *   /<site>/<curr>/<lang>/homepage/my-account
   *   /<site>/<curr>/<lang>/homepage/liveassist
   *   or root-level pages like:
   *   /login/my-account
   *   /homepage/my-account
   *   /homepage/liveassist
   */
  suppressErrorView: boolean = false;

  ngOnInit(): void {
    this.userInfoService.userLoggedIn$.subscribe(res => {
      this.userLoggedIn = res;
    });

    try {
      const path =
        typeof window !== 'undefined' && window.location
          ? (window.location.pathname || '')
          : '';

      // ✅ Suppress for:
      //   /login/my-account
      //   /homepage/my-account
      //   /homepage/liveassist
      this.suppressErrorView =
        /\/login\/my-account\/?$/.test(path) ||
        /\/homepage\/my-account\/?$/.test(path) ||
        /\/homepage\/liveassist\/?$/.test(path);

    } catch {
      this.suppressErrorView = false;
    }
  }
}